// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.undernav {
  background-color: var(--underNavBgColour);
  height: var(--underNavHeight);
  position: sticky;
  position: -moz-sticky;
  position: -o-sticky;
  position: -ms-sticky;
  z-index: 1010;
  top: var(--headerHeight);
  overflow-x: hidden;
  overflow-y: hidden;
  text-wrap: none;
}
.undernav .underbar-item {
  height: 33px;
  padding: 5px 12px;
  display: inline-block;
  line-height: 23px !important;
}
.undernav .underbar-item.selected {
  background-color: var(--underNavSelectedBgColour) !important;
  border-radius: 15px;
}
.undernav .underbar-item a.undernav-item, .undernav .underbar-item a.undernav-item:visited {
  color: var(--underNavTextColour) !important;
  font-weight: 500;
  font-size: 14px;
  display: inline-block;
}

.live-sales {
  background-color: var(--secondaryButtonColour);
  font-weight: 600;
  font-size: 0.8rem;
  line-height: 1.75rem;
}
.live-sales .container.side-bar {
  margin-left: 0;
  padding-left: calc(var(--searchMenuWidth) + 30px);
}
.live-sales .sale-name {
  display: inline-block;
  margin-right: 10px;
  font-weight: 300;
}
.live-sales a, .live-sales a:visited {
  color: #fff !important;
}
.live-sales .sale-counter {
  background-color: #fff;
  border-radius: 7px;
  display: inline-block;
  min-width: 14px;
  height: 14px;
  line-height: 14px;
  text-align: center;
  margin-right: 5px;
  font-size: 12px;
  font-weight: 800;
}

@media screen and (max-width: 1200px) {
  .live-sales .container.side-bar {
    padding-left: 0 !important;
    margin-left: 5%;
    margin-right: 5%;
  }
}
@media screen and (max-width: 992px) {
  .live-sales .container.side-bar {
    padding-left: 0 !important;
    margin-left: 2%;
    margin-right: 2%;
  }
}`, "",{"version":3,"sources":["webpack://./projects/remarq/src/app/components/common/app-undernavbar/app-undernavbar.component.scss"],"names":[],"mappings":"AAAA;EACE,yCAAA;EACA,6BAAA;EACA,gBAAA;EAEA,qBAAA;EACA,mBAAA;EACA,oBAAA;EACA,aAAA;EACA,wBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;AACF;AACE;EAEE,YAAA;EACA,iBAAA;EACA,qBAAA;EACA,4BAAA;AAAJ;AAEI;EACE,4DAAA;EACA,mBAAA;AAAN;AAGI;EACE,2CAAA;EACA,gBAAA;EACA,eAAA;EACA,qBAAA;AADN;;AAMA;EACE,8CAAA;EACA,gBAAA;EACA,iBAAA;EACA,oBAAA;AAHF;AAKE;EACE,cAAA;EACA,iDAAA;AAHJ;AAME;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;AAJJ;AAOE;EACE,sBAAA;AALJ;AAQE;EACE,sBAAA;EACA,kBAAA;EACA,qBAAA;EACA,eAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;AANJ;;AAUA;EAEI;IACE,0BAAA;IACA,eAAA;IACA,gBAAA;EARJ;AACF;AAYA;EAEI;IACE,0BAAA;IACA,eAAA;IACA,gBAAA;EAXJ;AACF","sourcesContent":[".undernav {\n  background-color: var(--underNavBgColour);\n  height: var(--underNavHeight);\n  position: sticky;\n  position: -webkit-sticky;\n  position: -moz-sticky;\n  position: -o-sticky;\n  position: -ms-sticky;\n  z-index: 1010;\n  top: var(--headerHeight);\n  overflow-x: hidden;\n  overflow-y: hidden;\n  text-wrap: none;\n\n  .underbar-item {\n\n    height: 33px;\n    padding: 5px 12px;\n    display: inline-block;\n    line-height: 23px !important;\n\n    &.selected {\n      background-color: var(--underNavSelectedBgColour) !important;\n      border-radius: 15px;\n    }\n\n    a.undernav-item, a.undernav-item:visited {\n      color: var(--underNavTextColour) !important;\n      font-weight: 500;\n      font-size: 14px;\n      display: inline-block;\n    }\n  }\n}\n\n.live-sales {\n  background-color: var(--secondaryButtonColour);\n  font-weight: 600;\n  font-size: 0.8rem;\n  line-height: 1.75rem;\n\n  .container.side-bar {\n    margin-left: 0;\n    padding-left: calc(var(--searchMenuWidth) + 30px);\n  }\n\n  .sale-name {\n    display: inline-block;\n    margin-right: 10px;\n    font-weight: 300;\n  }\n\n  a, a:visited {\n    color: #fff !important;\n  }\n\n  .sale-counter {\n    background-color: #fff;\n    border-radius: 7px;\n    display: inline-block;\n    min-width: 14px;\n    height: 14px;\n    line-height: 14px;\n    text-align: center;\n    margin-right: 5px;\n    font-size: 12px;\n    font-weight: 800;\n  }\n}\n\n@media screen and (max-width: 1200px) {\n  .live-sales {\n    .container.side-bar {\n      padding-left: 0 !important;\n      margin-left: 5%;\n      margin-right: 5%;\n    }\n  }\n}\n\n@media screen and (max-width: 992px) {\n  .live-sales {\n    .container.side-bar {\n      padding-left: 0 !important;\n      margin-left: 2%;\n      margin-right: 2%;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
